module.exports = __webpack_public_path__ + "static/media/33.f784379e.mp3";